import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import './UserMenu.css';

const UserMenu: React.FC = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Get user initials for avatar
  const getInitials = () => {
    if (!user || !user.name) return '?';
    
    const nameParts = user.name.split(' ');
    if (nameParts.length === 1) return nameParts[0].charAt(0).toUpperCase();
    
    return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
  };

  // Toggle menu open/closed
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Handle logout
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!user) return null;

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button 
        className="user-menu-button" 
        onClick={toggleMenu}
        aria-label="User Menu"
        aria-expanded={menuOpen}
      >
        <div className="user-avatar">
          {getInitials()}
        </div>
      </button>
      
      {menuOpen && (
        <div className="user-dropdown">
          <div className="user-info">
            <div className="user-avatar dropdown-avatar">
              {getInitials()}
            </div>
            <div className="user-details">
              <div className="user-name">{user.name}</div>
              <div className="user-email">{user.email}</div>
              <div className="user-role">{user.role}</div>
            </div>
          </div>
          
          <div className="menu-actions">
            <button 
              className="menu-item"
              onClick={() => {
                // For now just close the menu, could navigate to profile page in future
                setMenuOpen(false);
              }}
            >
              <span className="menu-icon">👤</span>
              <span>My Profile</span>
            </button>
            
            <button 
              className="menu-item logout-item"
              onClick={handleLogout}
            >
              <span className="menu-icon">🚪</span>
              <span>Log Out</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu; 